import { MDBAnimation, MDBBtn, MDBCol, MDBContainer, MDBRow } from 'mdbreact'
import React from 'react'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router-dom'
import ScrollToTop from '../Nav/ScrollToTop'
import CarouselComponent from '../Portfolio/CarouselComponent'
import { ProjectArray } from '../PortfolioModal/ProjectArray'
// import { StorageArray } from '../PortfolioModal/StorageArray';
import ReactHtmlParser from 'react-html-parser'

class StorageItem extends React.Component {
  render() {
    const query = new URLSearchParams(this.props.location.search)
    const id = query.get('id')
    const selectedStorageProject = ProjectArray.find((project) => project.id == id)
    const storageProjectName = (
      <>
        <h1>{selectedStorageProject.name}</h1>
      </>
    )
    // const storageProjectDescription = (
    //     <>

    //         <p>{selectedStorageProject.description}</p>
    //     </>
    // )
    return (
      <>
        <Helmet>
          <meta charSet='utf-8' />
          <title>{selectedStorageProject.name + ' | Current Kitchens'}</title>
          <meta
            name='description'
            content='We specialise in the design and installation of bespoke commercial and residential kitchens in Christchurch.'
          />
          <meta property='og:image' content={'https://www.currentkitchens.co.nz' + selectedStorageProject.coverImgUrl} />
          <link rel='canonical' href={'https://www.currentkitchens.co.nz/storage-item' + this.props.location.search} />
        </Helmet>
        <div className='storage-page-header d-flex justify-content-center align-items-center page-header header-filter clear-filter dark-filter'>
          <MDBCol md='6' className='header-text mx-auto text-left header-text-center'>
            <div className='pt-5'>
              <MDBAnimation reveal type='fadeInDown' className='fast'>
                <h1 className='h4-responsive beige-text text-uppercase mt-5 mb-2'>Our Portfolio</h1>
              </MDBAnimation>
              <MDBAnimation reveal type='fadeInUp' className='fast'>
                <h1 className='h1-responsive font-weight-md'>{storageProjectName}</h1>
              </MDBAnimation>
            </div>
          </MDBCol>
        </div>
        <MDBContainer>
          <MDBRow className='pt-5'>
            <MDBCol md='1' className='text-left'>
              <i class='fas fa-chevron-left fa-lg  mt-3 mb-4 pointer' onClick={() => this.props.history.push('/our-storage')}></i>
            </MDBCol>
            <MDBCol md='11'>
              <div className='h6-responsive mb-5 text-left mt-2'>{ReactHtmlParser(selectedStorageProject.description)}</div>
            </MDBCol>
          </MDBRow>
          <ScrollToTop />
          <div
            style={{
              paddingBottom: '5rem'
            }}
          >
            <CarouselComponent projectTypeArray={ProjectArray} selectedTypeProject={selectedStorageProject} />

            <div className='text-left mt-lg-5 mt-5'>
              <MDBBtn color='secondary' className='text-left mt-lg-5 mt-2' onClick={() => this.props.history.push(`/our-storage`)}>
                Back
              </MDBBtn>
            </div>
          </div>
        </MDBContainer>
      </>
    )
  }
}

export default withRouter(StorageItem)
